import { useForm, zodResolver } from '@mantine/form';
import { useState } from 'react';

import { TSDListItem, TSDSimulatorAcceptedPayload, TSDSimulatorAcceptedPayloadSchema } from '@e-origin/contracts';
import { appendIfFilled } from '@e-origin/shared';

interface UseSimulatorFormInitializerProps {
  tsd: TSDListItem;
  onHide(): void;
  onSubmit(payload?: Record<string, unknown>): Promise<void> | void;
}

export const useSimulateTsdAcceptedFormInitializer = ({ tsd, onHide, onSubmit }: UseSimulatorFormInitializerProps) => {
  const [submitting, setSubmitting] = useState(false);

  const buildFormValues = (): TSDSimulatorAcceptedPayload => ({
    crn: tsd.messageInfo?.CRN || '',
    mrn: tsd.messageInfo?.MRN || '',
    frn: tsd.messageInfo?.FRN || '',
    businessValidationType: tsd.customsState?.businessValidationType || '',
    status: '',
  });

  const form = useForm<TSDSimulatorAcceptedPayload>({
    initialValues: buildFormValues(),
    validate: zodResolver(TSDSimulatorAcceptedPayloadSchema),
    validateInputOnBlur: true,
  });

  // eslint-disable-next-line max-statements
  const onSubmitForm = async (values: TSDSimulatorAcceptedPayload) => {
    try {
      setSubmitting(true);

      const payload: Record<string, unknown> = {};

      appendIfFilled(payload, 'crn', values.crn);
      appendIfFilled(payload, 'mrn', values.mrn);
      appendIfFilled(payload, 'frn', values.frn);
      appendIfFilled(payload, 'businessValidationType', values.businessValidationType);
      appendIfFilled(payload, 'status', values.status);

      await onSubmit(payload);
    } catch {
      // toast handled by mutation
    } finally {
      setSubmitting(false);
      onHide();
    }
  };

  return { form, onSubmit: onSubmitForm, buildFormValues, submitting };
};
